import Vuex from "vuex";
import Vue from "vue";
import { graphqlClient } from "../utils/graphql";
import gql from "graphql-tag";
import { TEMPLATES_NAME_QUERY } from "@/models/queries/TemplatesNameQuery";
import { TEMPLATES_OVERVIEW_QUERY } from "@/models/queries/TemplatesOverviewQuery";
import { ADD_TEMPLATE_MUTATION } from "@/models/mutations/AddTemplateMutation";
import { REMOVE_TEMPLATE_FROM_PRODUCT_MUTATION } from "@/models/mutations/RemoveTemplateFromProductMutation";
import { TEMPLATE_DETAIL_QUERY } from "@/models/queries/TemplateDetail";
import { TemplateDetail, TemplateDetailVariables } from "@/models/queries/types/TemplateDetail";

Vue.use(Vuex);

const templateStore = {
  namespaced: true,
  state: {
    templates: [],
    fetching: false,
    hasError: false
  },
  mutations: {
    BEGIN(state) {
      state.fetching = true;
    },
    ERROR(state, message) {
      state.hasError = message;
      state.fetching = false;
    },
    FETCH(state, templates) {
      state.templates = templates;
      state.fetching = false;
    }
  },
  actions: {
    fetch({ commit }) {
      commit("BEGIN");
      return graphqlClient
        .query({
          query: gql`
            ${TEMPLATES_OVERVIEW_QUERY}
          `,
          variables: {}
        })
        .then(response => commit("FETCH", response.data.templates))
        .catch(error => console.log(error));
    },
    save({}, template) {
      return graphqlClient.mutate({
        mutation: gql`
          ${ADD_TEMPLATE_MUTATION}
        `,
        variables: {
          name: template.name,
          characteristicIds: template.characteristics.map(c => c.id)
        }
      });
    },
    removeTemplateFromProduct({}, { productId, templateId }) {
      return graphqlClient.mutate({
        mutation: gql`
          ${REMOVE_TEMPLATE_FROM_PRODUCT_MUTATION}
        `,
        variables: {
          productId,
          templateId
        }
      });
    },
    fetchTemplateNames() {
      return graphqlClient.query({
        query: gql`
          ${TEMPLATES_NAME_QUERY}
        `,
        variables: {}
      });
    },
    loadTemplateDetail({}, { templateId }) {
      return graphqlClient.mutate<TemplateDetail, TemplateDetailVariables>({
        mutation: TEMPLATE_DETAIL_QUERY,
        variables: {
          templateId
        }
      });
    }
  }
};

export default templateStore;
